import { useEffect } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { cryptoRateActions, useBettingCurrency } from '@namespace/user';

const { LOAD_CRYPTO_RATE } = cryptoRateActions;

const useRates = () => {
  const bettingCurrency = useBettingCurrency();
  const { crypto = {} } = useOtherSettings();
  const { isNeedLoadRates } = crypto;

  useEffect(() => {
    if (isNeedLoadRates) {
      LOAD_CRYPTO_RATE(bettingCurrency || 'USD');
    }
  }, [bettingCurrency, isNeedLoadRates]);
};

export default useRates;
